import dataBloedErnstigDOAC from "../../../../src/data/ernstige-bloedingen-onder-doac-dabigatran.json";
import BasicCollapse from "../../../../src/components/chart/interaction/basic-collapse/Chart.js";
import * as React from 'react';
export default {
  dataBloedErnstigDOAC,
  BasicCollapse,
  React
};